const en = {
  genderTxt: 'Gender',
  gender: 'Male',
  ageTxt: 'Age',
  heightTxt: 'Height',
  weightTxt: 'Weight',
  occupationTxt: 'Occupation',
};

export default en;
